import { Table } from 'semantic-ui-react';
import DateFormat from './DateFormat';
import React from 'react';
import { useIntl } from 'react-intl';

const prefix = 'taskRow';
export default function TaskRow({ eachTask, isIssueDetail }) {
  const intl = useIntl();
  function formatString(status) {
    return intl.formatMessage({ id: `${prefix}.${status}`, defaultMessage: status });
  }

  return (
    <>
      <Table.Row>
        <Table.Cell className="task-id">{eachTask.task_id}</Table.Cell>
        <Table.Cell className="center status">{formatString(eachTask.status)}</Table.Cell>
        <Table.Cell className="due-date">
          <DateFormat date={eachTask.due_date[0]} inFormat={'DD-MMM-YYYY'}></DateFormat>
        </Table.Cell>
        <Table.Cell className="assignee">
          <ul className="user-list">
            {eachTask?.assignees?.map((assignee) => {
              return <li key={assignee}>{assignee} </li>;
            })}
          </ul>
        </Table.Cell>
        <Table.Cell className="title">{eachTask.title}</Table.Cell>
        {isIssueDetail && <Table.Cell className="stage-name">{eachTask.stageDataName}</Table.Cell>}
      </Table.Row>
    </>
  );
}
